import { useState } from 'react';
import {
  DEFAULT_LIMIT,
  getPaginationLimit,
  isPaginationLimit,
  PaginationLimit,
  PaginationScreenKey,
  savePaginationLimit,
} from '../services/paginationLimitService';

/** Page size of one list screen, persisted in localStorage. */
export default function usePaginationLimit(
  screen: PaginationScreenKey,
  defaultLimit: PaginationLimit = DEFAULT_LIMIT,
): [PaginationLimit, (limit: number) => void] {
  const [limit, setLimit] = useState(() => getPaginationLimit(screen, defaultLimit));

  function changeLimit(value: number): void {
    if (!isPaginationLimit(value)) {
      return;
    }

    savePaginationLimit(screen, value);
    setLimit(value);
  }

  return [limit, changeLimit];
}
